import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MEMBER_INFO_UPDATE, MEMBERS_DETAIL } from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import { CONSTANT, LOADING_KEY } from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import { PlatformComponent } from '../platform.component';
import { DICVALUES_API_CONSTANT } from 'src/app/shared/constant/api-constant';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-b101',
  templateUrl: './b101.component.html',
  styleUrls: ['./b101.component.scss', '../platform.component.scss'],
})

/**
 * 自治体会員登録・更新画面(入力)(B101)
 * 自治体会員登録・更新画面(確認画面)(B102)
 */
export class B101Component extends PlatformComponent {
  // 画面.入力フォーム
  b101InputForm: FormGroup = this.formBuilder.group({
    // 会員種別
    class_id: this.formBuilder.control(CONSTANT.EMPTY_STRING),
    // 団体名称
    organization_name: this.formBuilder.control(CONSTANT.EMPTY_STRING),
    // 団体名称（フリガナ）
    organization_kana: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'organization_kana',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 法人番号
    organization_no: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'organization_no',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 郵便番号
    postal_no: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'postal_no',
          INPUT_INFORMATIONS_API_CONSTANT.NUMBER_TYPE
        ),
      ],
    }),
    // 都道府県
    prefectures: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'prefectures',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 所在地（市区町村）
    city: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'city',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 所在地（町域）
    town_area: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'town_area',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 所在地（番地・建物）
    address_building: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'address_building',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    //団体ウェブサイトURL
    url: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'url',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 人口
    population: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'population',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    //重点的に取り組みたいテーマ
    category_activities_forcus: this.formBuilder.control(
      CONSTANT.EMPTY_STRING,
      {
        asyncValidators: [
          this.validator.CheckValidator(
            'member',
            'category_activities_forcus',
            INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
          ),
        ],
      }
    ),
    // SDGsで目指すゴール
    category_activities: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'category_activities',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    //実現したいこと
    want: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'want',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    //現在SDGsの取り組み
    activities_now: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'activities_now',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    //今後取り組みたい内容
    activities_future: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'activities_future',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    //業種
    industry_id: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'industry_id',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 従業員数
    employees_count: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'employees_count',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 売上高
    sales_amount: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'sales_amount',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 主要事業
    primary_business: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'primary_business',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績１（案件名）
    pap_ally1_title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally1_title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績１（連携団体）
    pap_ally1_member_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally1_member_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績１（概要）
    pap_ally1_note: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally1_note',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績2（案件名）
    pap_ally2_title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally2_title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績2（連携団体）
    pap_ally2_member_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally2_member_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績２（概要）
    pap_ally2_note: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally2_note',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績3（案件名）
    pap_ally3_title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally3_title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績3（連携団体）
    pap_ally3_member_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally3_member_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 官民連携実績3（概要）
    pap_ally3_note: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'pap_ally3_note',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  //　会員ID
  memberId: string = this.route.snapshot.queryParams.member_id;

  // 会員種別ID
  classId: number = this.route.snapshot.queryParams.class_id;

  // 確認画面表示フラグ(true=自治体会員登録・更新登録確認(B102),false=自治体会員登録・更新画面(入力）(B101)
  confirmationFlag: boolean = false;

  // 業種用辞書値格納先
  industryIdCodeList: any;

  // 業種用辞書値(目指すゴール)格納先
  dicList_3: any;

  //目指すゴールリスト格納先
  category_activities: any[] = new Array();


  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを自治体会員登録・更新画面(入力）(B101)に変更する
    this.router.navigate(['pages/platform/b101/' + this.inputType], {
      queryParams: {
        screenId: 'b101',
        member_id: this.memberId,
        class_id: this.classId,
      },
    });
  }

  async ngOnInit() {
    await this.getUserLogin();
    if(!this.decisionPerspective(this.memberId)
      && !this.decisionSecretariat()
    ){
      // 異常メッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00003),
          detail: this.commonService.msg(MESSAGE_CODE.E80002),
          position: TOAST.BOTTOM_RIGHT,
          life: 60000,
        })
      );
      this.loginService.logout(MESSAGE_CODE.N90001);
      return;
    }
    // 辞書値リストを取得
    this.getSpecCodeList(1, 2, 3, 4, 5, 6, 701);

    // 業務用辞書情報取得処理
    this.dbOperationService.getDicLists(2).subscribe((response) => {
      // 全辞書情報が存在するか否か
      if (!this.commonService.checkNoneResponse(response)) {
        // 辞書情報に存在する場合

        // 辞書情報を格納
        this.industryIdCodeList = response.body;
      } else {
        // 辞書情報に存在しない場合

        this.industryIdCodeList = null;
      }
    });

    // 業務用辞書情報取得処理
    this.dbOperationService.getDicLists(3).subscribe((response) => {
      // 全辞書情報が存在するか否か
      if (!this.commonService.checkNoneResponse(response)) {
        // 辞書情報に存在する場合

        // 辞書情報を格納
        this.dicList_3 = response.body;
      } else {
        // 辞書情報に存在しない場合

        this.dicList_3 = null;
      }
    });



    // 課題カテゴリを取得
    this.getAgendaCategoryList();

    // 編集初期表示
    this.setEditInitialData();

    // 変動フォームコントロールを設定
    // 会員種別IDを判定
    if (1 == this.classId || 2 == this.classId) {
      // 自治体または省庁の場合

      // 以下項目を非活性
      this.b101InputForm.get('employees_count').disable();
      this.b101InputForm.get('sales_amount').disable();
      this.b101InputForm.get('primary_business').disable();
      this.b101InputForm.get('pap_ally1_title').disable();
      this.b101InputForm.get('pap_ally1_member_name').disable();
      this.b101InputForm.get('pap_ally1_note').disable();
      this.b101InputForm.get('pap_ally2_title').disable();
      this.b101InputForm.get('pap_ally2_member_name').disable();
      this.b101InputForm.get('pap_ally2_note').disable();
      this.b101InputForm.get('pap_ally3_title').disable();
      this.b101InputForm.get('pap_ally3_member_name').disable();
      this.b101InputForm.get('pap_ally3_note').disable();
    } else if (3 == this.classId) {
      // 民間団体の場合

      // 人口を非活性
      this.b101InputForm.get('population').disable();
    }
    //省庁の場合
    if (2 == this.classId) {
      //さらに人口を非活性
      this.b101InputForm.get('population').disable();
    }
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });

  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MEMBERS_DETAIL);

    // 会員プロフィール詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(MEMBERS_DETAIL, this.memberId, true)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.b101InputForm,
          response.body
        );

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MEMBERS_DETAIL);
      });
  }

  /**
   * 自治体会員登録・更新画面(入力)(B101)を表示する
   */
  public moveB101(): void {
    // 会員登録・更新画面(入力)(B101)へ遷移
    this.router.navigate(['pages/platform/b101/edit'], {
      queryParams: {
        screenId: 'b101',
        member_id: this.memberId,
        class_id: this.classId,
      },
    });

    // 自治体会員登録・更新画面(入力)(B101)を表示する
    this.confirmationFlag = false;
  }

  /**
   * 自治体会員登録・更新画面(確認画面)(B102)を表示する
   */
  public moveB102(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し

    let b101InputForm: any = JSON.parse(
      JSON.stringify(this.b101InputForm.value)
    );

    // 配列をカンマ区切り変換
    {
      // 重点的に取り組みたいテーマ
      b101InputForm.category_activities_forcus =
        b101InputForm.category_activities_forcus.toString();

      // SDGsで目指すゴール
      b101InputForm.category_activities =
        b101InputForm.category_activities.toString();
    }

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult('member', b101InputForm),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 自治体会員登録・更新画面(確認画面)(B102)へ遷移
      this.router.navigate(
        ['pages/platform/b101/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'b102',
            member_id: this.memberId,
            class_id: this.classId,
          },
        }
      );

      // 自治体会員登録・更新画面(確認画面)(B102)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   *自治体会員登録・更新画面(登録・更新完了)(B103)へ遷移する
   */
  public moveB103(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し

    let b101InputForm: any = JSON.parse(
      JSON.stringify(this.b101InputForm.value)
    );

    // 配列をカンマ区切り変換
    {
      // 重点的に取り組みたいテーマ
      b101InputForm.category_activities_forcus =
        b101InputForm.category_activities_forcus.toString();

      // SDGsで目指すゴール
      b101InputForm.category_activities =
        b101InputForm.category_activities.toString();
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 自治体会員プロファイル更新を実施
      this.dbOperationService
        .updateData(MEMBER_INFO_UPDATE, this.memberId, b101InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 自治体会員登録・更新画面(登録・更新完了)(B103)へ遷移
            this.router.navigate(['pages/platform/b103'], {
              queryParams: {
                member_id: this.memberId,
                class_id: this.classId,
              },
            });
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            //  自治体会員登録・更新画面(入力)(B101)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }

  /**
   * チェックボックス全選択
   */
   protected setCheckAll(event: PointerEvent, checkflag: boolean) {
    event.preventDefault()
    if(checkflag){
      let declist = new Array() ;
      this.dicList_3.forEach((value) => { declist.push(value.sp_code);})
      this.category_activities = declist;
    }else{
      this.category_activities = new Array();
    }
  }

}
